import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import WaitingModal from '../../generics/WaitingModal';
import FlatButton from 'material-ui/FlatButton';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import Notifications from 'react-notify-toast';

var Config = require('../../../config');

class ModalSupplies extends Component{
	constructor(props){
		super(props);
		
		this.handleClose = this.handleClose.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);

		this.state = {
			show: false, 
			reason_id:"",
			reasons:[],
            donation_id:0,
            items:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleClose(){
		this.setState({
            show: false,
            items:[]
		});
	}

	handleShow(donation_id){
		this.setState({donation_id:donation_id});
		this.waiting_modal.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'donation_use_reagents/get_by_donation?donation_id='+donation_id,{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				console.log(res.text())
			}
		}).then(response => {
			if(response !== undefined){
                var items = [];
                response.supplies_required.forEach(item => {
                    item.selected = "";

                    var index = response.supplies_used.findIndex(obj => obj.supplies_reagents_id === item.id);

                    if(index !== -1){
                        item.selected = response.supplies_used[index].lot_number;
                    }
                })

				this.setState({
					show:true, 
					items: response.supplies_required
				});

				this.waiting_modal.handleClose();
			}
		})

	}

	handleChange(e, i){
        var items = this.state.items;

        items[i].selected = e.target.value;
		this.setState({
			items: items
		});

		
	}

	onSave(){
        var obj = [];

        this.state.items.forEach(item => {
            if(obj.selected !== ""){
                obj.push({
                    supplies_reagents_id: item.id,
                    lot_number: item.selected
                });
            }
        })

		if(obj.length === 0){			
			swal("Error", "Debe seleccionar por lo menos un valor", 'error');
		}else{
			this.props.waiting.handleShow('Liberando...');
			fetch(Config.default.apiGateway.URL+'donation_use_reagents?donation_id='+this.state.donation_id,{ 
                method: 'POST',
                body:JSON.stringify(obj),
	            headers: new Headers({
	               	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	               	'Accept': 'application/json',
	              	'Content-Type': 'application/json',
	            })
	      	}).then(res => {
	      		this.props.waiting.handleClose();
	            if(res.ok){
	              	return res.json();
	            }else{
	              	res.text().then(function(result) {
	                	swal('¡Error!', result, 'error');
	              	});
	            }
	        }).then(res => {
	          	if(res !== undefined){
	            	swal('¡Buen Trabajo!', '','success');
	            	this.handleClose();
	          	};
	      	});
		}
			
	}

	render(){
		const {t} = this.props;

		return (
			<div>
				<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
			       	<Modal.Header closeButton>
			        	<Modal.Title>Registro de insumos</Modal.Title>
			        </Modal.Header>
			        <Modal.Body >
			        	<div className="row">
			        		<div className="col-xs-12 form-group ">
                                {this.state.items.map((item, i)=>
                                    
                                    <div className="col-xs-12 form-group" key={i}>
                                        <div className="col-xs-12 col-sm-6">
                                            <label>{item.name}</label>
                                        </div>
                                        <div className="col-xs-12 col-sm-6">
                                            <select className="form-control" value={item.selected} onChange={(e)=>this.handleChange(e, i)}>
                                                <option value="">Seleccione...</option>
                                                {item.stock.map((stock, j)=>
                                                    <option value={stock.lot_number} key={j}>{stock.lot_number}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    
                                )}			        			
			        		</div>
			        	</div>
			        	
			        </Modal.Body>
			        <Modal.Footer>
			        	<FlatButton primary={true} label={t('content.generics.buttons.save')}  onClick={this.onSave}/>
			        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
			        </Modal.Footer>
		      	</Modal>
		      	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)} />
		      	<Notifications />
	      	</div>
		)
	}
}

export default translate('translations')(ModalSupplies)